import { render, staticRenderFns } from "./BalanceTab.vue?vue&type=template&id=10635f34"
import script from "./BalanceTab.vue?vue&type=script&lang=js"
export * from "./BalanceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports